// extracted by mini-css-extract-plugin
module.exports = {"centr":"Loader_centr__1x0n_","Loader":"Loader_Loader__3jglw","lds-roller":"Loader_lds-roller__2sTtw"};